/* v8 ignore start */
import {JsonModel} from "@/lib/core/jsonModel";
import {LottieImageLayerModel} from "@/lib/lottie/layers/lottieImageLayerModel";
import {LottieNullLayerModel} from "@/lib/lottie/layers/lottieNullLayerModel";
import {LottiePrecompositionLayerModel} from "@/lib/lottie/layers/lottiePrecompositionLayerModel";
import {LottieShapeLayerModel} from "@/lib/lottie/layers/lottieShapeLayerModel";
import {LottieSolidColorLayerModel} from "@/lib/lottie/layers/lottieSolidColorLayerModel";
import {LottieTextLayerModel} from "@/lib/lottie/layers/lottieTextLayerModel";

export class LottieCompositionModel<
  T extends LottieCompositionModel.IJson = LottieCompositionModel.IJson,
> extends JsonModel<T> {}

export namespace LottieCompositionModel {
  export type TLayerType =
    | LottiePrecompositionLayerModel.IJson
    | LottieSolidColorLayerModel.IJson
    | LottieImageLayerModel.IJson
    | LottieNullLayerModel.IJson
    | LottieTextLayerModel.IJson
    | LottieShapeLayerModel.IJson;

  export interface IJson {
    /**
     * Layers in the composition
     */
    layers: TLayerType[];
  }
}
/* v8 ignore stop */
